import { Component, ChangeDetectorRef, Inject } from '@angular/core';
import {
  getDeepFromObject,
  NbAuthService,
  NB_AUTH_OPTIONS,
  NbTokenService,
} from '@nebular/auth';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
    selector: 'ngx-login',
    templateUrl: './login.component.html',
    styleUrls: ['login.component.scss'],
})
export class NgxLoginComponent {
    redirectDelay: number = 0;
    showMessages: any = {};
    strategy: string = '';
    errors: string[] = [];
    messages: string[] = [];
    user: any = {};
    submitted: boolean = false;
    rememberMe = false;
    showRecoverPassword = false;
    emailRecoverPassword: string = '';
    loading = false;
    hide = true;

    constructor(
        protected service: NbAuthService,
        protected authService: AuthService,
        @Inject(NB_AUTH_OPTIONS) protected options = {},
        protected cd: ChangeDetectorRef,
        protected tokenService: NbTokenService,
        protected router: Router,
      ) {
        this.tokenService.clear();
        this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
        this.showMessages = this.getConfigValue('forms.login.showMessages');
        this.strategy = this.getConfigValue('forms.login.strategy');
        this.rememberMe = this.getConfigValue('forms.login.rememberMe');
    }

    async login() {
        this.errors = [];
        this.messages = [];
        this.submitted = true;
        this.loading = true;
        const [error] = await this.authService.login(this.user);
        this.loading = false;
        if (error) {
          this.user.password = '';
          this.submitted = false;
          if (error.error.message.includes('INVALID_PASSWORD')) {
            return this.showError('Contraseña incorrecta, intenta nuevamente');
          }

          if (error.error.message.includes('TOO_MANY_ATTEMPTS_TRY_LATER')) {
            return this.showError('Demasiados intentos, espera unos minutos y vuelve a intentarlo, si no recuerdas tu contraseña realiza el proceso de recuperación de contraseña');
          }

          return this.showError('Ocurrió un error, intenta más tarde');
        }
        this.router.navigate(['/pages/notificaciones']);
    }

    getConfigValue(key: string): any {
        return getDeepFromObject(this.options, key, null);
    }

  async recoverPassword() {
    await this.authService.recoverUser(this.emailRecoverPassword);
    const options: any = {
      title: '¡Excelente!',
      text: 'Te hemos enviado un correo electrónico para reestablecer tu contraseña',
      type: 'success',
      confirmButtonText: 'Ok',
    };
    Swal.fire(options).then(_ => {
      this.showRecoverPassword = false;
      this.emailRecoverPassword = '';
    });
  }

  async showError(message) {
    await this.authService.recoverUser(this.emailRecoverPassword);
    const options: any = {
      title: 'Oops',
      text: message,
      type: 'error',
      confirmButtonText: 'Ok',
    };

    await Swal.fire(options);
  }

}
